import { render, staticRenderFns } from "./KiymetTakdiriForm.vue?vue&type=template&id=002b090f&scoped=true"
import script from "./KiymetTakdiriForm.vue?vue&type=script&lang=ts"
export * from "./KiymetTakdiriForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002b090f",
  null
  
)

export default component.exports